import { Image, UnstyledButton, disabledStyle } from "@wayflyer/flyui";
import { styled } from "styled-components";

import { sizeMap, supportedConnectorMap } from "./connector-logo.const";

type StyledConnectorLogoProps = {
  ariaLabel?: any;
};

export type ConnectorLogoSize = "standard" | "large" | "small";

export type ConnectorLogoProps = StyledConnectorLogoProps & {
  key?: string | number;
  connectorName: string;
  alt?: string;
  size?: ConnectorLogoSize;
  disabled?: boolean;
};

export const ConnectorLogoButton = styled(UnstyledButton)`
  border-radius: var(--defaults-borderRadius);
  border: 1px solid var(--palette-border-neutral-subtle);
  background-color: var(--palette-bg-neutral-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  position: relative;
  cursor: unset;

  &:hover,
  &.active {
    border-width: 2px;
    border-color: var(--palette-border-neutral-subtle);
    background-color: var(--palette-bg-neutral-base);
  }

  &:disabled {
    ${disabledStyle}
  }
`;

export const ConnectorLogoButtonWithHover = styled(ConnectorLogoButton)`
  cursor: pointer;
  &:hover,
  &.active {
    border: 2px solid var(--palette-content-status-positive);
    box-shadow: 0 0 3px var(--palette-content-status-positive);
  }
`;

export const StyledConnectorLogo = styled(Image)<{
  $size: ConnectorLogoSize;
  $padded?: boolean;
}>`
  width: ${({ $size = "standard", $padded = false }) => sizeMap[$size].full - ($padded ? 20 : 0)}px;
  height: ${({ $size = "standard", $padded = false }) => sizeMap[$size].full - ($padded ? 20 : 0)}px;
  border-radius: var(--sizes-radius-sm);
  padding: ${({ $padded = false }) => ($padded ? "10px" : "0")};
  @media (max-width: 640px) {
    width: ${({ $size = "standard" }) => sizeMap[$size].reduced}px;
    height: ${({ $size = "standard" }) => sizeMap[$size].reduced}px;
  }
  /**
    Improves layout for iPhones
   */
  @media (width: 414px) {
    width: ${({ $size = "standard" }) => sizeMap[$size].full}px;
    height: ${({ $size = "standard" }) => sizeMap[$size].full}px;
  }
`;

export const ConnectorLogo = (props: ConnectorLogoProps) => {
  const { connectorName, alt = "", ariaLabel = "", size = "small", ...other } = props;
  const logoSource = supportedConnectorMap[connectorName];

  return (
    <StyledConnectorLogo
      {...other}
      $size={size}
      src={logoSource}
      alt={alt}
      title={connectorName}
      aria-label={ariaLabel}
    />
  );
};
